import { Component, Input, OnInit } from '@angular/core';
import icHome from '@iconify/icons-ic/twotone-home';
import { trackByValue } from '../../utils/track-by';

@Component({
  selector: "vex-breadcrumbs",
  template: `
    <div class="flex items-center change-cl h-full">
      <vex-breadcrumb>
        <!-- <ic-icon [icon]="icHome" inline="true" size="20px" ></ic-icon> -->
      </vex-breadcrumb>
      <ng-container *ngFor="let crumb of crumbs; trackBy: trackByValue">
        <!-- <div class="w-1 h-1 bg-gray rounded-full ltr:mr-2 rtl:ml-2 change-cl"></div> -->
        <vex-breadcrumb>
          <a style="color:#0C2C6C">{{ crumb }}</a>
        </vex-breadcrumb>
       
      </ng-container>
    </div>
  `,
})
export class BreadcrumbsComponent implements OnInit {
  @Input() crumbs: string[] = [];

  trackByValue = trackByValue;
  icHome = icHome;

  constructor() {}

  ngOnInit() {}
}
